// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2Rphu","title":"AfterFrontImage_title__2QALV"};